import { RootState } from "../../../../store";
import { alertsStateSelector } from "../../alertsStateSelector";

export const alertsDataSelector = (state: RootState) => {
  const alertsState = alertsStateSelector(state);

  return alertsState.data;
};
